module.exports = __webpack_public_path__ + "media/images/bg-c03f503ffad9e843187861224008c957.webp";